import React, { useEffect } from 'react';
import InputType from './ComponentsTpes/InputType';

const EntryButton =   ({  fieldsData, componentSourceOptions ,
    selectedPorts, setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Entry_button:{
                    ...prevData.Entry_button,
                    [key]: value
                }
            }
        })
    }


    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Entry_button.component_source.value}
        condition={savedData.Entry_button.condition}
        input={savedData.Entry_button.input}
        name={savedData.Entry_button.name}
        fieldsData={fieldsData}
    />)
}

export default EntryButton;